import React from 'react';
import { Link } from 'react-router-dom';
import UserProfilePic from '../common/UserProfilePic'; // Import the new component

const ProfileSection = ({ user, setShowLogoutConfirm, activeItem, isMobile = false }) => {
  return (
    <>
      {/* Profile direct link */}
      <Link
        to="/dashboard"
        className="rounded-full text-white hover:bg-brand-teal-light hover:text-white"
      >
        {/* Use the new UserProfilePic component */}
        <UserProfilePic user={user} className="w-8 h-8" altText={user?.username || 'User profile'} />
      </Link>
      
      {/* Direct logout button - only show in desktop view */}
      {!isMobile && (
        <button
          onClick={() => setShowLogoutConfirm(true)}
          className="p-2 rounded-full text-white hover:bg-brand-teal-light hover:text-white"
          aria-label="Logout"
        >
          <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
        </button>
      )}
    </>
  );
};

export default ProfileSection;